import route from "@/components/router/Router"

export default {
    path : "company-item-origin",
    name : "company-item-origin",
    meta : {
        title : "项目来源管理",
    },
    redirect : {
        name : "company-item-origin-edit",
    },
    component: route,
    children : [
        {
            path: 'edit',
            name: 'company-item-origin-edit',
            meta: {
                title: '项目来源管理-单位管理'
            },
            component: () => import('@/pages/company/itemOrigin/Index'),
        }
    ]
}



// WEBPACK FOOTER //
// ./src/router/company/itemOrigin/index.js